export const toastSemanticTokens = {
  bg: {
    success: { value: "{colors.green.200}" },
    error: { value: "{colors.tertiary.lightRed}" },
    info: { value: "{colors.tertiary.lightBlue}" },
    warning: { value: "{colors.tertiary.lightYellow}" },
  },
  text: {
    success: { value: "{colors.success.dark}" },
    error: { value: "{colors.primary.white}" },
    info: { value: "{colors.primary.white}" },
    warning: { value: "{colors.primary.black}" },
  },
  border: {
    success: { value: "{colors.green.700}" },
    error: { value: "{colors.status.error}" },
    info: { value: "{colors.status.info}" },
    warning: { value: "{colors.status.warning}" },
  },
  radii: {
    success: { value: "radii.2xl" },
    error: { value: "radii.2xl" },
    info: { value: "radii.2xl" },
    warning: { value: "radii.2xl" },
  },
};
